<template>
  <div class="scene-list">
    <Scene
      v-for="scene in scenes"
      :key="scene.id"
      :scene-id="scene.id"
      :scene-name="scene.name"
      :image-url="scene.imageUrl"
    />
  </div>
</template>
<script>
import Scene from './Scene'
export default {
  components: { Scene },
  props: {
    scenes: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$emit('mount')
    })
  }
}
</script>
<style lang="scss" scoped>
.scene-list {
  @extend %custom-scrollbar;
  display: flex;
  overflow: visible;
}
</style>
